import { User } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

interface PatientInfoCardProps {
  info: {
    urn: string
    episodeNumber: string
    weight: string
    height: string
    bsa: string
  }
}

export function PatientInfoCard({ info }: PatientInfoCardProps) {
  return (
    <Card className="rounded-xl shadow-sm border">
      <CardHeader className="pt-2 pb-6">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <User className="h-4 w-4 text-teal-600" />
          Patient Information
        </CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-2 gap-y-3 pt-0">
        <div>
          <div className="text-xs text-muted-foreground">URN</div>
          <div className="text-sm font-medium">{info.urn}</div>
        </div>
        <div>
          <div className="text-xs text-muted-foreground">Episode Number</div>
          <div className="text-sm font-medium">{info.episodeNumber}</div>
        </div>
        <div>
          <div className="text-xs text-muted-foreground">Weight</div>
          <div className="text-sm font-medium">{info.weight}</div>
        </div>
        <div>
          <div className="text-xs text-muted-foreground">Height</div>
          <div className="text-sm font-medium">{info.height}</div>
        </div>
        <div className="col-span-2">
          <div className="text-xs text-muted-foreground">BSA</div>
          <div className="text-sm font-medium">{info.bsa}</div>
        </div>
      </CardContent>
    </Card>
  )
}
